import { Controller } from "@hotwired/stimulus"

// Drives a native <dialog> injected into <body> by an HTMX fetch. Unlike
// confirm-dialog (which opens on a button click), this opens itself on connect
// and removes the whole element from the DOM when the dialog closes, so
// repeated fetches don't stack orphaned dialogs in <body>. The copy action
// writes the prompt textarea to the clipboard.
export default class extends Controller {
  static targets = ["dialog", "source"]

  connect() {
    this.dialogTarget.showModal()
  }

  close(event) {
    if (event) event.preventDefault()
    this.dialogTarget.close()
  }

  // Close when the user clicks the backdrop (outside the dialog's content box).
  backdropClose(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  // Wired to the dialog's native "close" event, which fires for the close
  // buttons, Escape, and backdrop close — so the element always self-cleans.
  remove() {
    this.element.remove()
  }

  copy(event) {
    const button = event.currentTarget
    navigator.clipboard.writeText(this.sourceTarget.value).then(() => {
      const original = button.innerHTML
      button.innerHTML = "Copied!"
      setTimeout(() => { button.innerHTML = original }, 1500)
    })
  }
}
